import {Component, Inject, ViewEncapsulation, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";
import {ReservationData} from "../../models/reservationData";
import {UserService} from "../../services";
import {User} from "../../models";
import {ServiceService} from "../../services/service.service";
import {Service} from "../../models/service";
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';

export const MY_FORMATS = {
    parse: {
        dateInput: ['YYYY-MM-DD']
    },
    display: {
        dateInput: 'YYYY-MM-DD',
        monthYearLabel: 'YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'YYYY',
    },
};

import { MomentDateAdapter } from '@angular/material-moment-adapter';
import {DateAdapter} from "angular-calendar";
import {MAT_DATE_FORMATS, MAT_DATE_LOCALE} from "@angular/material/core";
import {first} from "rxjs/operators";
import {CustomerDialogComponent} from "../../customer/dialog/customerDialog.component";
import {ServiceResourceGroup} from "../../models/serviceResourceGroup";
import {EmployeeSchedule} from "../../models/employeeSchedule";
import {DeleteEventDialogComponent} from "../../calendar/dialog/deleteEventDialog.component";
import {DeleteEmployeeScheduleDialogComponent} from "./deleteEmployeeScheduleDialog.component";
import {EmployeeScheduleService} from "../../services/employeeSchedule.service";

@Component({
    selector: 'employee-schedule-form-dialog',
    templateUrl: './employeeScheduleDialog.component.html',
    styleUrls: ['./employeeScheduleDialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    ]
})

export class EmployeeScheduleDialogComponent implements OnInit {
    action: string;
    categories: any[];
    employeeSchedule: EmployeeSchedule;
    form: FormGroup;
    dialogTitle: string;
    username: string;
    customers: User[];
    workers: User[];
    showSeconds = false;
    stepHour = 1;
    stepMinute = 1;
    stepSecond = 0;
    touchUi = true;
    hideTime = false;
    color = "primary";
    services: Service[];
    event: any;
    dialogRef: any;
    worker: User;
    scheduleDate: Date;
    locale: string;
    filteredOptions: Observable<User[]>;
    schedule: any;
    deleteDialogRef: any;


    /**
     *
     * @param matDialogRef
     * @param _data
     * @param _formBuilder
     * @param translationLoader
     * @param translate
     */
    constructor(
        public matDialogRef: MatDialogRef<EmployeeScheduleDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _formBuilder: FormBuilder,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService,
        private userService: UserService,
        private serviceService: ServiceService,
        public _matDialog: MatDialog,
        private formBuilder: FormBuilder,
        private employeeScheduleService: EmployeeScheduleService,
    ) {
        this.translationLoader.loadTranslations(polish);
        // Set the defaults

        this.action = _data.action;
        this.event = _data.event;
        this.worker = _data.worker;
        this.locale = _data.locale;
        this.schedule = _data.schedule;

        if (this.action === 'edit') {
            translate.get('Edit employee schedule').subscribe((text: string) => {
                this.dialogTitle = text
            });

            this.employeeSchedule = _data.schedule.meta.schedule;
            this.username = _data.schedule.meta.schedule.user.firstName + ' ' + _data.schedule.meta.schedule.user.lastName;
            this.scheduleDate = new Date(_data.schedule.start);
        } else {
            translate.get('New employee schedule').subscribe((text: string) => {
                this.dialogTitle = text
            });
            
            this.employeeSchedule = new EmployeeSchedule();
            this.employeeSchedule.user = new User();
            this.employeeSchedule.user.id = this.schedule.user.id;
            this.employeeSchedule.startDate = this.schedule.date;
            this.employeeSchedule.endDate = this.schedule.date;
            this.username = this.schedule.user.name;
            this.scheduleDate = this.schedule.date;
        }

        this.form = this.createEmployeeScheduleForm();

        if (this.action === 'new') {
            this.addHour();
        } else {
            this.addHour();
            this.hours().at(0).get('startHour').setValue(_data.schedule.meta.startHour);
            this.hours().at(0).get('endHour').setValue(_data.schedule.meta.endHour);
        }
    }

    ngOnInit() {

    }

    displayFn(userId: User): string {
        return (userId)? userId.firstName + ' ' + userId.lastName + '; ' + userId.phone: '';
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Create contact form
     *
     * @returns {FormGroup}
     */
    createEmployeeScheduleForm(): FormGroup {
        return this._formBuilder.group({
            id: [this.employeeSchedule.id],
            description: [this.employeeSchedule.description],
            hours: this.formBuilder.array([]),
            userId: [this.employeeSchedule.user.id],
            date: [this.employeeSchedule.startDate]
        });
    }

    get f() { return this.form.controls; }

    hours(): FormArray {
        return this.form.get('hours') as FormArray;
    }

    newHour(): FormGroup {
        let HOUR_PATTERN = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
        return this.formBuilder.group({
            startHour: ['', [Validators.pattern(HOUR_PATTERN), Validators.required]],
            endHour: ['', [Validators.pattern(HOUR_PATTERN), Validators.required]],
        });
    }

    addHour() {
        this.hours().push(this.newHour());
    }

    removeHour(hourIdx: number) {
        this.hours().removeAt(hourIdx);
    }

    showConfirmEmployeeScheduleDeleteDialog(schedule) {
        this.deleteDialogRef = this._matDialog.open(DeleteEmployeeScheduleDialogComponent, {
            panelClass: 'contact-form-dialog',
            data      : {
                action : 'show',
                schedule: schedule,
            },
            width: '350px',
        });

        this.deleteDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.employeeScheduleService.delete(schedule.id).pipe(first())
                    .subscribe(response => {
                        window.location.reload();
                    }, error => {
                        console.log(error);
                    });

                this.deleteDialogRef.close();
            }, (err) => {
                console.log(err);
            });
    }
}
